export class OcspConfig {

    url ?: any;
    enable ?: boolean;


}
